import React from 'react';
import VmBackupsSection from './VmBackupsSection';
import VmLiveSnapshotsSection from './VmLiveSnapshotsSection';

interface VmSnapshotsTabProps {
  vmId: number;
  vmName: string;
}

/**
 * The VM's Snapshots tab: two **independent** sections over the same idea at different distances.
 *
 * - **Snapshots** — live, on the hypervisor, mutable, short-lived.
 * - **Backups** — copies on the backup server, read-only, retention-managed. Conceptually these
 *   are relocated snapshots, which is why they belong here rather than in a tab of their own.
 *
 * Each section owns its loading, error and empty states **locally**. That is the whole point of
 * this composition: the tab previously returned early from all three states, so a slow, failed or
 * (most commonly) empty snapshot call hid everything below it. Neither section can now suppress
 * the other.
 */
const VmSnapshotsTab: React.FunctionComponent<VmSnapshotsTabProps> = ({ vmId, vmName }) => (
  // PatternFly renders a tab's body flush against the tab bar, so the top padding lives here and
  // covers every state both sections can render — not just the ones with rows.
  <div className="pf-v6-u-pt-md">
    <VmLiveSnapshotsSection vmId={vmId} vmName={vmName} />
    <VmBackupsSection vmId={vmId} />
  </div>
);

export default VmSnapshotsTab;
